function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#4e5ca9",
  d: "M1 1h43.9v43.9H1z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#fb7d74",
  d: "M1 27.4h43.9V45H1z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fill: "none",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 2,
  d: "M1 1h43.9v43.9H1z"
});

var SvgLegendCumulativeColors = function SvgLegendCumulativeColors(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 46 46",
    xmlSpace: "preserve"
  }, props), React.createElement("title", null, title), _ref2, _ref3, _ref4);
};

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDIzLjAuNiwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHZpZXdCb3g9IjAgMCA0NiA0NiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNDYgNDY7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4KCS5zdDB7ZmlsbDojNEU1Q0E5O30KCS5zdDF7ZmlsbDojRkI3RDc0O30KCS5zdDJ7ZmlsbDpub25lO3N0cm9rZTojRkZGRkZGO3N0cm9rZS13aWR0aDoyO3N0cm9rZS1taXRlcmxpbWl0OjEwO30KPC9zdHlsZT4KPGcgaWQ9ImJhY2siPgo8L2c+CjxnPgoJPGc+CgkJPHJlY3QgeD0iMSIgeT0iMSIgY2xhc3M9InN0MCIgd2lkdGg9IjQzLjkiIGhlaWdodD0iNDMuOSIvPgoJCTxyZWN0IHg9IjEiIHk9IjI3LjQiIGNsYXNzPSJzdDEiIHdpZHRoPSI0My45IiBoZWlnaHQ9IjE3LjYiLz4KCQk8cmVjdCB4PSIxIiB5PSIxIiBjbGFzcz0ic3QyIiB3aWR0aD0iNDMuOSIgaGVpZ2h0PSI0My45Ii8+Cgk8L2c+CjwvZz4KPC9zdmc+Cg==";
export { SvgLegendCumulativeColors as ReactComponent };